// extracted by mini-css-extract-plugin
module.exports = {"Question":"FaqSingleQuestionPreview_Question__LQIAC","Single":"FaqSingleQuestionPreview_Single__3mhxK"};